import { FunctionComponent, PropsWithChildren } from "react";
import { Dialog } from "@headlessui/react";
import { cn } from "../../utils/cn";

export interface ModalTitleProps {
  className?: string;
  "data-testid"?: string;
}

/**
 *
 */
export const ModalTitle: FunctionComponent<
  PropsWithChildren<ModalTitleProps>
> = ({ className, children, "data-testid": dataTestId }) => {
  const testId = dataTestId || "modal-title";
  return (
    <Dialog.Title
      as="h3"
      className={cn("text-lg leading-6 font-medium text-gray-900", className)}
      data-testid={testId}
    >
      {children}
    </Dialog.Title>
  );
};
